webpackJsonp([114276838955818,60335399758886],{

/***/ 165:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(263);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(165);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/olaveapåFbogTwitterSmalere.7b0a4de6.png";

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(127);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _olaveapFbogTwitterSmalere = __webpack_require__(505);
	
	var _olaveapFbogTwitterSmalere2 = _interopRequireDefault(_olaveapFbogTwitterSmalere);
	
	var _typography = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    {
	      style: {
	        borderTop: "4px solid lightblue"
	      }
	    },
	    _react2.default.createElement(
	      "div",
	      {
	        style: {
	          marginLeft: "auto",
	          marginRight: "auto",
	          maxWidth: (0, _typography.rhythm)(24),
	          padding: (0, _typography.rhythm)(2) + " " + (0, _typography.rhythm)(0.75),
	          paddingBottom: "" + (0, _typography.rhythm)(1)
	        }
	      },
	      children()
	    ),
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement("img", {
	        style: {
	          margin: 0,
	          display: "block",
	          border: "4px solid lightblue",
	          width: "100%"
	
	        },
	        src: _olaveapFbogTwitterSmalere2.default
	      })
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-f0a9e8e836ebf4e6fb7a.js